import { safeJson } from "@/lib/http";
import { supabase } from "@/lib/supabase";

const BASE = process.env.REACT_APP_BACKEND_URL;
const BUCKET = "dataroom";
const MAX_BYTES = 50 * 1024 * 1024;
const safeName = (name) => String(name).replace(/[^a-zA-Z0-9._-]/g, "_").slice(-150);

async function token() {
    const { data } = await supabase.auth.getSession();
    const t = data.session?.access_token;
    if (!t) throw new Error("Session expirée, reconnectez-vous.");
    return t;
}

async function call(path, method = "GET", body) {
    const r = await fetch(`${BASE}${path}`, { method, headers: { Authorization: `Bearer ${await token()}`, ...(body ? { "Content-Type": "application/json" } : {}) }, body: body ? JSON.stringify(body) : undefined });
    if (r.status === 204) return null;
    const j = await safeJson(r);
    if (!r.ok) throw new Error(typeof j.detail === "string" ? j.detail : `Erreur ${r.status}`);
    return j;
}

export const listRapportsMensuels = (dossierId) => call(`/api/dossiers/${dossierId}/rapports-mensuels`);
export const ensureRapportMensuel = (dossierId, body) => call(`/api/dossiers/${dossierId}/rapports-mensuels`, "POST", body);
export const getRapportMensuel = (id) => call(`/api/rapports-mensuels/${id}`);
export const saveRmSections = (id, sections) => call(`/api/rapports-mensuels/${id}/sections`, "PUT", { sections });
export const generateRm = (id) => call(`/api/rapports-mensuels/${id}/generate-async`, "POST", {});
export const pollRm = (jobId, dossierId) => call(`/api/rapports-mensuels/generate/${jobId}?dossier_id=${dossierId}`);
const registerPreuve = (id, body) => call(`/api/rapports-mensuels/${id}/preuves`, "POST", body);
export const deletePreuve = (id, preuveId) => call(`/api/rapports-mensuels/${id}/preuves/${preuveId}`, "DELETE");

export async function uploadPreuve(dossierId, rapportId, categorie, file) {
    if (file.size > MAX_BYTES) throw new Error("Fichier trop volumineux (50 Mo maximum).");
    const path = `${dossierId}/rapports-mensuels/${rapportId}/${crypto.randomUUID()}-${safeName(file.name)}`;
    const { error } = await supabase.storage.from(BUCKET).upload(path, file, { contentType: file.type || undefined, upsert: false });
    if (error) throw error;
    try {
        return await registerPreuve(rapportId, { categorie, nom_fichier: file.name, url_stockage: path, content_type: file.type || null, taille: file.size });
    } catch (e) {
        await supabase.storage.from(BUCKET).remove([path]).catch(() => {});
        throw e;
    }
}

export async function downloadRmPdf(id) {
    const r = await fetch(`${BASE}/api/rapports-mensuels/${id}/pdf`, { headers: { Authorization: `Bearer ${await token()}` } });
    if (!r.ok) { const j = await safeJson(r); throw new Error(typeof j.detail === "string" ? j.detail : `Erreur ${r.status}`); }
    const blob = await r.blob();
    const name = (r.headers.get("Content-Disposition") || "").match(/filename="([^"]+)"/)?.[1] || "Rapport_Mensuel.pdf";
    const url = URL.createObjectURL(blob);
    const a = Object.assign(document.createElement("a"), { href: url, download: name });
    a.click();
    URL.revokeObjectURL(url);
}
